import {
  Component,
  inject,
  Input,
  OnDestroy,
  ViewEncapsulation,
} from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subscription } from 'rxjs';
import { ToggleNavigationOpen } from '../../../../stores/app/navbar.state';
import { SideMenuStore } from '../../../../stores/app/side-menu.state';
import { NavigationService } from './navbar.service';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { NkNavigationModule } from '../../../../components';
import { SvgIconUrlPipe } from '../../../../pipes/svgIconUrl.pipe';
import { AsyncPipe, NgIf } from '@angular/common';

import { NkNavigationComponent } from '../../../../components/navigation/navigation.component';
import { MatSidenavModule } from '@angular/material/sidenav';
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports:[
     MatButtonModule,
    MatIconModule,
    NkNavigationModule,
    RouterModule,
    NkNavigationComponent,
    SvgIconUrlPipe,
    AsyncPipe, 
    NgIf,
    MatSidenavModule
  ]
})
export class NkNavbarComponent implements  OnDestroy {
  @Input() layout = 'vertical';

  public navMenu$: Observable<any> = inject(Store).select(SideMenuStore.navMenu);

  public navigation: any;

  private onNavigationChangedSubscription!: Subscription;

  constructor(
    private readonly navService: NavigationService,
    private readonly store: Store
  ) {}

 

  public ngOnDestroy() {
    this.onNavigationChangedSubscription?.unsubscribe();
  }

  public toggleSidebarOpened() {

  this.store.dispatch(new ToggleNavigationOpen());
  }
}
